// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');

// @ constants
const { FIRST_STEP } = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { PREMIUM_PACK_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC, CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCardPremiumPackStep1 extends React.Component {

    componentDidMount() {
        const {
            flagBasedFeatures,
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['premium_pack_card'].preContractPdfLink;
            const product = {
                type: '501',
                subtype: '003',
                standard: '0000003'
            };
            const showIneAndRevolving = flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
            if (!showIneAndRevolving) {
                requestPDFMerge(pdfurls, [product]);
            }
        } else {
            setTermsAndCondsText('hireCardPremiumPack-step4CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        const { showIneAndRevolving } = this.props;
        if (!__CONTACT_CENTER__ || showIneAndRevolving) return null;

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardPremiumPack,
            sendMailParams,
        } = this.props;

        const immStep = immHireCardPremiumPack.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value="hireCardPremiumPack-step4CheckboxText" />;
        const agreementErrorMsg = formatText('hireCardPremiumPack-step4CheckboxErrorMsg');

        return (
            <ContactCenterValidationCards
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName={contractName}
                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                immStep={immStep}
                sendMailParams={sendMailParams}
            />
        );
    }


    render() {
        const { immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={PREMIUM_PACK_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-premium-pack__step-one">
                    <FormattedText
                        className="hire-card-premium-pack__step-title"
                        value="hireCardPremiumPack-step1Title"
                    />
                    <HireInformation
                        collectiveEnabled
                        collectiveLocation="Contrataciones_Paso_colectivos_premiumpack_1"
                        hireCmsKey={__CONTACT_CENTER__ ? "Contrataciones_Paso_default_premiumpack_cc_1" : "Contrataciones_Paso_default_premiumpack_1"}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}


HireCardPremiumPackStep1.propTypes = {
    contractName: PropTypes.string,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    immHireInformation: PropTypes.object.isRequired,
    immHireCardPremiumPack: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardPremiumPackStep1;
